/* eslint-disable max-lines */
// eslint-disable-next-line max-lines-per-function
define( [ 'utility', 'blocks/m-notification-badge' ], function run( utility, mNotificationBadge ) {
	'use strict';

	var oMastheadFn = {

		settings : {
			closeMenu : FRAMEWORK.locale.settings.oMasthead.closeMenu,
			closeText : FRAMEWORK.locale.settings.oMasthead.closeText,
			loadingText : FRAMEWORK.locale.settings.oMasthead.loadingText,
			animationSpeed : FRAMEWORK.timings.current.t350ms,
			busy : false,
		},

		// eslint-disable-next-line complexity
		init : function( elm ) {
			// Get the wrapping div for the page.
			var wholePageElm = elm.closest( '.l-whole-page' ),
				menuId = utility.makeId( 'nav' ),
				menuLinkHtml = '<li class="o-masthead__menu-link"><a href="#' + menuId + '">' + FRAMEWORK.locale.settings.oMasthead.menuText + '</a></li>',
				skipLinksElm;

			// Check if the masthead has already been setup. If so do nothing more.
			if ( !wholePageElm.classList.contains( 'js-o-masthead' ) ) {
				// Add class to page so that setup is not run again.
				wholePageElm.classList.add( 'js-o-masthead' );

				// Store all common element searches as settings for quick reuse
				elm.oMasthead = {
					settings : {
						currentBreakpoint : null,
						current : null,
					},
				};
				elm.oMasthead.settings.wholePageElm = wholePageElm;
				elm.oMasthead.settings.mastheadElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead' );
				elm.oMasthead.settings.logoElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead-logo' );
				elm.oMasthead.settings.navContainerElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead__navigation-container' );
				elm.oMasthead.settings.pageWrapperElm = elm.oMasthead.settings.wholePageElm.querySelector( '.l-page-wrapper' );
				elm.oMasthead.settings.wholeNavElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead-navigation' );
				elm.oMasthead.settings.navLinkElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead__menu-link a' );
				if ( utility.isNode( elm.oMasthead.settings.navLinkElm ) ) {
					elm.oMasthead.settings.navLinkHidden = elm.oMasthead.settings.navLinkElm.querySelector( '.u-hidden--visually' );
					if ( elm.oMasthead.settings.navLinkHidden ) {
						elm.oMasthead.settings.navLinkHidden.remove();
					}
					elm.oMasthead.settings.navElm = elm.oMasthead.settings.wholePageElm.querySelector( elm.oMasthead.settings.navLinkElm.getAttribute( 'href' ) );
				} else if ( elm.oMasthead.settings.wholeNavElm ) {
					skipLinksElm = elm.oMasthead.settings.mastheadElm.querySelector( '.o-masthead__skip-links' );
					if ( skipLinksElm ) {
						skipLinksElm.prepend( utility.htmlStringToElement( menuLinkHtml ) );
						elm.oMasthead.settings.navLinkElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead__menu-link a' );
						// Create a dummy primary nav element and append it to the masthead navigation area
						elm.oMasthead.settings.navElm = utility.htmlStringToElement( '<div id="' + menuId + '" class="m-primary-navigation"></div>' );
						elm.oMasthead.settings.wholeNavElm.querySelector( '.l-content-container' ).append( elm.oMasthead.settings.navElm );
					}
				} else {
					// Do nothing
				}
				elm.oMasthead.settings.orphanPrimaryNavElm = elm.oMasthead.settings.wholePageElm.querySelector( '.m-primary-navigation' );
				elm.oMasthead.settings.navSectionHeadingLinks = elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation__section-heading a' );
				elm.oMasthead.settings.navSubSections = [];
				elm.oMasthead.settings.navBasicLinks = elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation__link-list a' );

				oMastheadFn.processSkipLink( elm, '.o-masthead__login-link a', 'login' );
				oMastheadFn.processSkipLink( elm, '.o-masthead__logged-in-link a', 'loggedIn' );
				oMastheadFn.processSkipLink( elm, '.o-masthead__search-link a', 'search' );

				elm.oMasthead.settings.topBarElm = elm.oMasthead.settings.wholePageElm.querySelector( '.m-site-country-selection' );
				if ( utility.isNode( elm.oMasthead.settings.topBarElm ) ) {
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--has-top-bar' );
				}

				elm.oMasthead.settings.countryLinkElm = elm.oMasthead.settings.wholePageElm.querySelector( '.m-site-country-selection__country a' );
				elm.oMasthead.settings.countryLinkUrl = '';

				elm.oMasthead.settings.mastheadNotification = elm.oMasthead.settings.wholePageElm.querySelector( '.m-site-country-selection__notification' );
				if ( elm.oMasthead.settings.mastheadNotification ) {
					elm.oMasthead.settings.mastheadNotificationInstance = mNotificationBadge.initInstance( elm.oMasthead.settings.mastheadNotification.querySelector( '.m-notification-badge' ) );
				}

				elm.oMasthead.settings.allSkipLinks = elm.oMasthead.settings.wholePageElm.querySelectorAll( '.o-masthead-main-content a, .o-masthead__skip-links a' );
				oMastheadFn.processOtherSkipLinks( elm );
				elm.oMasthead.settings.extraContentAreaElm = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead__extra-content' );
				if ( utility.isNode( elm.oMasthead.settings.extraContentAreaElm ) ) {
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--has-extra-content' );
				}

				elm.oMasthead.settings.currentBreakpoint = utility.getBreakpoint( elm );
				elm.oMasthead.settings.windowWidth = window.innerWidth;

				elm.oMasthead.settings.changeInProgress = false;


				// If no navigation area has been included because there is no login, search or menu then add one to the page before the footer
				if ( utility.isNode( elm.oMasthead.settings.wholeNavElm ) ) {
					elm.oMasthead.settings.wholeNavElm.classList.add( 't-accent-light' );
					elm.oMasthead.settings.wholeNavElm.classList.add( 't-accent-light--1' );
				} else {
					elm.oMasthead.settings.wholeNavElm = utility.htmlStringToElement( '<div class="o-masthead-navigation' +
						' t-accent-light t-accent-light--1 u-clear--inner"><div class="l-content-container"></div></div>' );
					elm.oMasthead.settings.wholePageElm.querySelector( '.m-footer' ).insertAdjacentElement( 'beforebegin', elm.oMasthead.settings.wholeNavElm );
				}

				// Move Navigation to just below the masthead to maintain content ordering for when CSS is off but JavaScript is on
				elm.oMasthead.settings.pageWrapperElm.prepend( elm.oMasthead.settings.wholeNavElm );
				if ( utility.isNode( document.querySelector( '.framework-wrapper' ) ) ) {
					utility.wrap( elm.oMasthead.settings.wholeNavElm, utility.htmlStringToElement( '<div class="framework-wrapper"></div>' ) );
				}

				elm.oMasthead.settings.narrowMenu = false;

				oMastheadFn.setupSiteSwitcher( elm );

				// Run setup on the main links that can be in the header
				oMastheadFn.setupLink( elm, elm.oMasthead.settings.navLinkElm, elm.oMasthead.settings.navElm );
				oMastheadFn.setupLink( elm, elm.oMasthead.settings.loginLinkElm, elm.oMasthead.settings.loginElm );
				oMastheadFn.setupLink( elm, elm.oMasthead.settings.loggedInLinkElm, elm.oMasthead.settings.loggedInElm );
				oMastheadFn.setupLink( elm, elm.oMasthead.settings.searchLinkElm, elm.oMasthead.settings.searchElm );
				oMastheadFn.setupCountryLink( elm );

				// Build up the primary navigation system
				oMastheadFn.buildPrimaryNav( elm );

				// Correctly size and position elements with in the header area
				oMastheadFn.sizeNavElements( elm, elm.oMasthead.settings.currentBreakpoint );
				oMastheadFn.positionNav( elm, elm.oMasthead.settings.currentBreakpoint );

				if ( utility.isNode( elm.oMasthead.settings.loggedInElm ) ) {
					elm.oMasthead.settings.wholePageElm.classList.add( 'has-logged-in' );
				}

				oMastheadFn.bindEvents( elm );
			}

			return elm.oMasthead;
		},

		instantHideShow : function( element, hide, fadeOnly ) {
			var ariaHidden = 'false',
				displayType = 'block',
				opacity = 1;
			if ( utility.isNode( element ) ) {
				if ( hide ) {
					ariaHidden = 'true';
					displayType = 'none';
					if ( fadeOnly ) {
						displayType = 'block';
						opacity = 0;
					}
				}
				element.setAttribute( 'aria-hidden', ariaHidden );
				element.style.display = displayType;
				if ( fadeOnly ) {
					element.style.opacity = opacity;
				}
			}
		},

		// eslint-disable-next-line complexity
		processSkipLink : function( elm, queryString, linkName ) {
			var validHref;

			elm.oMasthead.settings[ linkName + 'LinkElm' ] = elm.oMasthead.settings.wholePageElm.querySelector( queryString );
			// Only do more if the link is available
			if ( utility.isNode( elm.oMasthead.settings[ linkName + 'LinkElm' ] ) ) {
				elm.oMasthead.settings[ linkName + 'LinkUrl' ] = elm.oMasthead.settings[ linkName + 'LinkElm' ].getAttribute( 'href' );

				validHref = utility.urlAnchorRegExp.test( elm.oMasthead.settings[ linkName + 'LinkUrl' ] );

				if ( validHref ) {
					elm.oMasthead.settings[ linkName + 'Elm' ] = elm.oMasthead.settings.wholeNavElm.querySelector( elm.oMasthead.settings[ linkName + 'LinkUrl' ] );
				}

				if ( linkName === 'login' ) {
					elm.oMasthead.settings.loginLinkUrl = validHref ? elm.oMasthead.settings.loginLinkUrl : '';
					if ( elm.oMasthead.settings.loginLinkUrl !== '' ) {
						utility.wrapInner( elm.oMasthead.settings.loginLinkElm, utility.htmlStringToElement( '<span class="o-masthead__login-link-inner"></span>' ) );
						elm.oMasthead.settings.loginLinkHidden = elm.oMasthead.settings.loginLinkElm.querySelector( '.u-hidden--visually' );
						if ( elm.oMasthead.settings.loginLinkHidden ) {
							elm.oMasthead.settings.loginLinkHidden.remove();
						}
					}
				} else if ( linkName === 'loggedIn' ) {
					elm.oMasthead.settings.loggedInLinkName = elm.oMasthead.settings.wholePageElm.querySelector( '.o-masthead-logged-in-link__name' );
					if ( elm.oMasthead.settings.loggedInLinkName ) {
						if ( elm.oMasthead.settings.loggedInLinkName.hasAttribute( 'aria-hidden' ) ) {
							elm.oMasthead.settings.loggedInLinkName.removeAttribute( 'aria-hidden' );
						}
						elm.oMasthead.settings.loggedInLinkElm.parentNode.insertBefore( elm.oMasthead.settings.loggedInLinkName, elm.oMasthead.settings.loggedInLinkElm );
					}
					elm.oMasthead.settings.loggedInLinkHidden = elm.oMasthead.settings.loggedInLinkElm.querySelector( '.u-hidden--visually' );
					if ( elm.oMasthead.settings.loggedInLinkHidden ) {
						elm.oMasthead.settings.loggedInLinkHidden.remove();
					}
				} else if ( linkName === 'search' ) {
					if ( elm.oMasthead.settings.searchElm ) {
						elm.oMasthead.settings.searchInputElm = elm.oMasthead.settings.searchElm.querySelector( 'input[type="text"], input[type="search"]' );
					} else if ( validHref ) {
						elm.oMasthead.settings.searchInputElm = document.querySelector( elm.oMasthead.settings.searchLinkUrl );
					} else {
						// Do nothing
					}
					elm.oMasthead.settings.searchLinkElm.append( utility.htmlStringToElement( '<span class="o-masthead-search-link-ui"></span>' ) );

					elm.oMasthead.settings.searchLinkHidden = elm.oMasthead.settings.searchLinkElm.querySelector( '.u-hidden--visually' );
					if ( elm.oMasthead.settings.searchLinkHidden ) {
						elm.oMasthead.settings.searchLinkHidden.remove();
					}
				}
			}
		},

		processOtherSkipLinks : function( elm ) {
			elm.oMasthead.settings.allSkipLinks.forEach( function loop( linkElm ) {
				var scrollTargetHref,
					scrollTarget;
				if ( linkElm.closest( '.o-masthead__menu-link, .o-masthead__login-link, .o-masthead__search-link, .o-masthead__logged-in-link' ) ) {
					// If its the menu, login or search link do nothing
				} else {
					scrollTargetHref = linkElm.getAttribute( 'href' ).substring( 1 );
					scrollTarget = document.getElementById( scrollTargetHref );

					if ( scrollTarget ) {
						linkElm.addEventListener( 'click', function listener( e ) {
							e.preventDefault();
							utility.smoothScroll( 0, utility.offset( scrollTarget ).top, FRAMEWORK.timings.current.t350ms, null, function setFocus() {
								scrollTarget.focus(); // Set focus on the target element
								if ( !utility.matches( scrollTarget, ':focus' ) ) {
									// If the focus wasn't gained set tab index to minus one and transfer focus again
									scrollTarget.setAttribute( 'tabindex', '-1' );
									scrollTarget.focus();
								}
							});
						});
					}
				}
			});
		},

		setupSiteSwitcher : function( elm ) {
			var validSiteSwitcherHref;

			elm.oMasthead.settings.siteSwitcherLink = elm.oMasthead.settings.wholePageElm.querySelector( '.m-site-country-selection__site-switcher a' );
			elm.oMasthead.settings.hasSiteSwitcher = false;
			elm.oMasthead.settings.siteSwitcherOpen = false;
			if ( utility.isNode( elm.oMasthead.settings.siteSwitcherLink ) ) {
				elm.oMasthead.settings.siteSwitcherUrl = elm.oMasthead.settings.siteSwitcherLink.getAttribute( 'href' );
				validSiteSwitcherHref = utility.urlAnchorRegExp.test( elm.oMasthead.settings.siteSwitcherUrl );
				elm.oMasthead.settings.siteSwitcherUrl = validSiteSwitcherHref ? elm.oMasthead.settings.siteSwitcherUrl : '';

				if ( elm.oMasthead.settings.siteSwitcherUrl !== '' ) {
					elm.oMasthead.settings.siteSwitcherContent = document.querySelector( elm.oMasthead.settings.siteSwitcherUrl );
					if ( elm.oMasthead.settings.siteSwitcherContent ) {
						elm.oMasthead.settings.hasSiteSwitcher = true;
					}
				}
			}

			if ( elm.oMasthead.settings.hasSiteSwitcher ) {
				if ( elm.oMasthead.settings.siteSwitcherContent.getAttribute( 'data-highlight' ) === 'true' ) {
					elm.oMasthead.settings.siteSwitcherLink.parentNode.classList.add( 'm-site-country-selection__site-switcher--highlight' );
				}
				elm.oMasthead.settings.siteSwitcherContentInner = elm.oMasthead.settings.siteSwitcherContent.children[ 0 ];
				utility.setAttributes( elm.oMasthead.settings.siteSwitcherLink, {
					role : 'button',
					'aria-controls' : elm.oMasthead.settings.siteSwitcherUrl.replace( '#', '' ),
					'aria-expanded' : 'false',
				});
				elm.oMasthead.settings.siteSwitcherContent.classList.add( 'm-site-switcher--header' );
				oMastheadFn.instantHideShow( elm.oMasthead.settings.siteSwitcherContent, true, false );
				elm.oMasthead.settings.topBarElm.insertAdjacentElement( 'afterend', elm.oMasthead.settings.siteSwitcherContent );
				oMastheadFn.updateSiteSwitcherText( elm, elm.oMasthead.settings.siteSwitcherContent.querySelector( '.m-site-switcher__selected-option' ) );

				elm.oMasthead.settings.siteSwitcherLink.addEventListener( 'click', function listener( e ) {
					e.preventDefault();
					if ( elm.oMasthead.settings.busy ) {
						// Do nothing
					} else {
						elm.oMasthead.settings.busy = true;
						oMastheadFn.toggleSiteSwitcher( elm, false, true ); // Close any open masthead element;
					}
				});

				elm.oMasthead.settings.siteSwitcherContent.querySelectorAll( '.a-button' ).forEach( function loop( buttonElm ) {
					buttonElm.addEventListener( 'click', function listener( e ) {
						if ( elm.oMasthead.settings.busy || buttonElm.classList.contains( 'm-site-switcher__selected-option' ) ) {
							e.preventDefault();
						} else {
							elm.oMasthead.settings.busy = true;
							oMastheadFn.updateSiteSwitcherText( elm, buttonElm );
							oMastheadFn.toggleSiteSwitcher( elm, true, true );
						}
					});
				});

				oMastheadFn.siteSwitcherTabbing( elm );
			}
		},

		toggleSiteSwitcher : function( elm, close, complete ) {
			if ( elm.oMasthead.settings.hasSiteSwitcher ) {
				if ( elm.oMasthead.settings.siteSwitcherOpen || close ) {
					utility.fade( elm.oMasthead.settings.siteSwitcherContentInner, FRAMEWORK.timings.current.t200ms, { variant : 'out' });
					setTimeout( function timeoutFn() {
						utility.slideToggle( elm.oMasthead.settings.siteSwitcherContent, FRAMEWORK.timings.current.t300ms, {
							variant : 'up',
							callback : function() {
								elm.oMasthead.settings.siteSwitcherLink.classList.remove( 'is-open' );
								elm.oMasthead.settings.siteSwitcherLink.setAttribute( 'aria-expanded', 'false' );
								elm.oMasthead.settings.siteSwitcherOpen = false;
								if ( complete ) {
									elm.oMasthead.settings.busy = false;
								}
								if ( elm.oMasthead.settings.mastheadNotification ) {
									elm.oMasthead.settings.mastheadNotificationInstance.show();
								}
							},
						});
					}, FRAMEWORK.timings.current.t100ms );
				} else {
					oMastheadFn.close( elm, true, true ); // Close any open masthead element;
					oMastheadFn.instantHideShow( elm.oMasthead.settings.siteSwitcherContentInner, false, false );
					elm.oMasthead.settings.siteSwitcherContentInner.style.opacity = 0;
					utility.slideToggle( elm.oMasthead.settings.siteSwitcherContent, oMastheadFn.settings.animationSpeed, {
						variant : 'down',
						callback : function() {
							utility.fade( elm.oMasthead.settings.siteSwitcherContentInner, FRAMEWORK.timings.current.t200ms, {
								variant : 'in',
								callback : function() {
									elm.oMasthead.settings.siteSwitcherLink.classList.add( 'is-open' );
									elm.oMasthead.settings.siteSwitcherLink.setAttribute( 'aria-expanded', 'true' );
									elm.oMasthead.settings.siteSwitcherOpen = true;
									if ( complete ) {
										elm.oMasthead.settings.busy = false;
									}
								},
							});
						},
					});
					if ( elm.oMasthead.settings.mastheadNotification ) {
						setTimeout( function timeoutFn() {
							elm.oMasthead.settings.mastheadNotificationInstance.hide();
						}, 10 );
					}
				}
			}
		},

		updateSiteSwitcherText : function( elm, target ) {
			var selectedOption = elm.oMasthead.settings.siteSwitcherContent.querySelector( '.m-site-switcher__selected-option' ),
				siteName;
			if ( selectedOption ) {
				selectedOption.classList.remove( 'm-site-switcher__selected-option' );
				selectedOption.classList.remove( 'is-disabled' );
				selectedOption.removeAttribute( 'disabled' );
				selectedOption.removeAttribute( 'aria-current' );
				selectedOption.removeAttribute( 'tabIndex' );
			}

			if ( target === null ) {
				elm.oMasthead.settings.siteSwitcherLink.innerHTML = FRAMEWORK.locale.settings.oMasthead.switcherInitial;
			} else {
				target.classList.add( 'm-site-switcher__selected-option' );
				target.classList.add( 'is-disabled' );
				target.disabled = true;
				target.setAttribute( 'tabIndex', -1 );
				target.setAttribute( 'aria-current', 'true' );

				siteName = '<span>' + target.getAttribute( 'data-value' ) + '</span>';
				elm.oMasthead.settings.siteSwitcherLink.innerHTML = FRAMEWORK.locale.settings.oMasthead.switcherSelection.replace( '{option}', siteName );
			}
		},

		siteSwitcherTabbing : function( elm ) {
			elm.oMasthead.settings.siteSwitcherLink.addEventListener( 'keydown', function listener( e ) {
				// When tab has been pressed and site switcher is open transfer focus to first focusable element in site switcher
				if ( e.key === 'Tab' && !e.shiftKey && elm.oMasthead.settings.siteSwitcherOpen ) {
					e.preventDefault();
					elm.oMasthead.settings.siteSwitcherContent.querySelector( '.a-button:not(.is-disabled)' ).focus();
				} else {
					// Do nothing
				}
			});

			elm.oMasthead.settings.siteSwitcherContent.querySelectorAll( '.a-button, a' ).forEach( function loop( linkElm ) {
				linkElm.addEventListener( 'keydown', function listener( e ) {
					var allLinksInSiteSwitcher = elm.oMasthead.settings.siteSwitcherContent.querySelectorAll( '.a-button:not(.is-disabled), a:not(.is-disabled)' );
					if ( e.key === 'Tab' ) {
						// Tab pressed
						if ( e.shiftKey && linkElm === allLinksInSiteSwitcher[ 0 ] ) {
							// If shift also pressed and on first link in site switcher tranfer to site switcher link
							e.preventDefault();
							elm.oMasthead.settings.siteSwitcherLink.focus();
						} else if ( !e.shiftKey && linkElm === allLinksInSiteSwitcher[ allLinksInSiteSwitcher.length - 1 ] ) {
							// If no shift and on last link in site switcher tranfer focus to coutnry selector of first element in masthead
							e.preventDefault();
							if ( elm.oMasthead.settings.countryLinkElm ) {
								elm.oMasthead.settings.countryLinkElm.focus();
							} else {
								// Make first visible link focused
								oMastheadFn.getVisibleLinks( elm.oMasthead.settings.mastheadElm.querySelectorAll( 'a' ) )[ 0 ].focus();
							}
						} else {
							// Do nothing
						}
					}
				});
			});

			if ( elm.oMasthead.settings.countryLinkElm ) {
				elm.oMasthead.settings.countryLinkElm.addEventListener( 'keydown', function listener( e ) {
					var allNonDisabledLinks;
					// When tab has been pressed and site switcher is open transfer focus to first focusable element in site switcher
					if ( e.key === 'Tab' && elm.oMasthead.settings.siteSwitcherOpen ) {
						e.preventDefault();
						if ( e.shiftKey ) {
							allNonDisabledLinks = elm.oMasthead.settings.siteSwitcherContent.querySelectorAll( '.a-button:not(.is-disabled), a:not(.is-disabled)' );
							allNonDisabledLinks[ allNonDisabledLinks.length - 1 ].focus();
						} else {
							// Make first visible link focused
							oMastheadFn.getVisibleLinks( elm.oMasthead.settings.mastheadElm.querySelectorAll( 'a' ) )[ 0 ].focus();
						}
					} else {
						// Do nothing
					}
				});
			}
			oMastheadFn.getVisibleLinks( elm.oMasthead.settings.mastheadElm.querySelectorAll( 'a' ) ).forEach( function loop( visibleLinkElm ) {
				visibleLinkElm.addEventListener( 'keydown', function listener( e ) {
					var allNonDisabledLinks;
					if ( e.key === 'Tab' && e.shiftKey && elm.oMasthead.settings.siteSwitcherOpen ) {
						e.preventDefault();
						if ( elm.oMasthead.settings.countryLinkElm ) {
							elm.oMasthead.settings.countryLinkElm.focus();
						} else {
							allNonDisabledLinks = elm.oMasthead.settings.siteSwitcherContent.querySelectorAll( '.a-button:not(.is-disabled), a:not(.is-disabled)' );
							allNonDisabledLinks[ allNonDisabledLinks.length - 1 ].focus();
						}
					}
				});
			});
		},

		getVisibleLinks : function( allLinks ) {
			var visibleLinks = [];
			allLinks.forEach( function loop( currentLinkElm ) {
				if ( utility.isVisible( currentLinkElm ) ) {
					visibleLinks.push( currentLinkElm );
				}
			});

			return visibleLinks;
		},

		bindEvents : function( elm ) {
			var onResize,
				resizeRedraw = function() {
					var newBreakpoint = utility.getBreakpoint( elm ),
						wait = 0;

					// Check if the breakpoint has changed. If it had close any open nav items
					if ( newBreakpoint !== elm.oMasthead.settings.currentBreakpoint ) {
						if ( newBreakpoint === utility.smallTag && elm.oMasthead.settings.navLinkElm && elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) ) {
							elm.oMasthead.settings.navLinkElm.focus();
						}
						if ( elm.oMasthead.settings.countryLinkElm && elm.oMasthead.settings.countryLinkElm.classList.contains( 'is-open' ) ) {
							wait = oMastheadFn.settings.animationSpeed;
						}
						oMastheadFn.close( elm, true, true );
						elm.oMasthead.settings.currentBreakpoint = newBreakpoint;
						setTimeout( function timeoutFn() {
							oMastheadFn.resetPosition( elm, newBreakpoint );
						}, wait );
					} else if ( newBreakpoint === utility.smallTag ) {
						oMastheadFn.resetPosition( elm, newBreakpoint );
					} else {
						oMastheadFn.positionNav( elm, newBreakpoint );
					}
				},
				isMastheadButton = function( targetElm ) {
					var isButton = false;
					if ( targetElm.classList.contains( 'o-masthead-support__link' ) || utility.isNode( targetElm.closest( '.o-masthead-support__link' ) ) ) {
						isButton = true;
					} else if ( ( targetElm.classList.contains( 'a-button' ) || utility.isNode( targetElm.closest( '.a-button' ) ) ) && ( utility.isNode( targetElm.closest( '.m-primary-navigation-sub-section__link-list' ) ) || utility.isNode( targetElm.closest( '.m-primary-navigation-sub-section__link' ) ) || utility.isNode( targetElm.closest( '.m-primary-navigation .m-card' ) ) ) ) { // eslint-disable-line max-len
						isButton = true;
					} else {
						// Do nothing
					}

					return isButton;
				};

			// Set debounce function to stop resize function running too often
			onResize = utility.debounce( function listener() {
				var newWindowWidth = window.innerWidth;
				if ( newWindowWidth !== elm.oMasthead.settings.windowWidth ) {
					elm.oMasthead.settings.windowWidth = newWindowWidth;
					resizeRedraw();
				}
			}, 10 );
			elm.oMasthead.reDraw = utility.debounce( function listener() {
				resizeRedraw();
			}, 10 ); // Function to call if extraContent area is updated dynamically and requires the nav to be redrawn
			window.addEventListener( 'resize', onResize );

			// Keep the user within the header and open nav item when a nav item is open
			document.body.addEventListener( 'keydown', function listener( e ) {
				// If any visible anchor, input or button is hit then fire keydown function
				if ( ( e.key === 'Escape' || e.key === 'Esc' ) && elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) && !elm.oMasthead.settings.busy ) {
					// If escape key is pressed then close the menu
					elm.oMasthead.settings.busy = true;
					oMastheadFn.close( elm, true, true );
				} else if ( e.target.tagName.match( /^(A|INPUT|BUTTON)$/g ) && utility.isVisible( e.target ) ) {
					oMastheadFn.onKeydown( e, e.target, elm );
				}
			});
			document.addEventListener( 'click', function listener( e ) {
				// If the page wrapper is currently open
				if ( elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) ) {
					if ( e.target.closest( 'header' ) === null && e.target.closest( '.o-masthead-navigation' ) === null ) {
						e.preventDefault();
						oMastheadFn.close( elm, true, true );
					} else if ( isMastheadButton( e.target ) || e.target.closest( '.o-masthead-main-content' ) ) {
						oMastheadFn.close( elm, true, true );
					} else {
						// Do nothing
					}
				}
			});
			document.addEventListener( 'focusin', function listener( e ) {
				var test2 = utility.isNode( e.target ) && e.target.closest( 'header' ) === null && e.target.closest( '.o-masthead-navigation' ) === null;
				// If the page wrapper is currently open and focus has moved off the menu
				if ( elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) && test2 ) {
					oMastheadFn.close( elm, true, true );
				}
			});
		},

		resetPosition : function( elm, newBreakpoint ) {
			oMastheadFn.sizeNavElements( elm, newBreakpoint );
			oMastheadFn.positionNav( elm, newBreakpoint );
		},

		setupLink : function( elm, linkElm, areaElm ) {
			var linkHref,
				validHref,
				tempAreaElm,
				setFocusFunc;

			// If the link and its connected navigation area exist do the following
			if ( utility.isNode( linkElm ) && utility.isNode( areaElm ) ) {
				linkHref = linkElm.getAttribute( 'href' );

				/*
				 * Add area to the link and navigation area and preset the minimum link width
				 * for when link text is switched out.
				 */
				utility.setAttributes( linkElm, {
					role : 'button',
					'aria-controls' : linkHref.replace( '#', '' ),
					'aria-expanded' : 'false',
				});
				oMastheadFn.instantHideShow( areaElm, true, false );

				/*
				 * Set onclick function that closes the navigation if this links navigation
				 * is already open, otherwise opens the navigation
				 */
				linkElm.addEventListener( 'click', function listener( e ) {
					e.preventDefault();

					if ( elm.oMasthead.settings.busy || elm.oMasthead.settings.changeInProgress ) {
						// Do nothing
					} else {
						elm.oMasthead.settings.busy = true;
						elm.oMasthead.settings.changeInProgress = true;

						if ( linkHref === elm.oMasthead.settings.current ) {
							oMastheadFn.close( elm, true, true );
						} else {
							oMastheadFn.open( elm, linkElm, areaElm );
						}
					}
				});

				// If this is the login link setup the login and register buttons for desktop
				if ( utility.isNode( linkElm ) && linkElm === elm.oMasthead.settings.loginLinkElm ) {
					elm.oMasthead.settings.loginLinkElm.insertAdjacentElement( 'beforebegin', elm.oMasthead.settings.loginElm.querySelector( '.o-masthead-login__link-list' ).cloneNode( true ) );
				}
			} else if ( linkElm === null ) {
				// Do nothing
			} else {
				linkHref = linkElm.getAttribute( 'href' );
				validHref = utility.urlAnchorRegExp.test( linkHref );

				if ( validHref ) {
					tempAreaElm = document.querySelector( linkHref );
					if ( utility.isNode( tempAreaElm ) ) {
						setFocusFunc = function() {
							tempAreaElm.focus(); // Set focus on the target element
							if ( !utility.matches( tempAreaElm, ':focus' ) ) {
								// If the focus wasn't gained set tab index to minus one and transfer focus again
								tempAreaElm.setAttribute( 'tabindex', '-1' );
								tempAreaElm.focus();
							}
						};
						linkElm.classList.add( 'js-tabbable' );
						linkElm.addEventListener( 'click', function listener( e ) {
							var tempAreaPos = utility.offset( tempAreaElm ).top,
								tempAreaHeight = tempAreaElm.offsetHeight,
								windowHeight = window.innerHeight,
								windowPos = window.pageYOffset;

							e.preventDefault();

							if ( tempAreaPos < windowPos || tempAreaPos > ( windowPos + windowHeight - tempAreaHeight ) ) {
								utility.smoothScroll( 0, tempAreaPos, FRAMEWORK.timings.current.t150ms, null, setFocusFunc );
							} else {
								setFocusFunc();
							}
						});
					}
				}
			}
		},

		setupCountryLink : function( elm ) {
			// Run setup for the country selector link if one exists
			if ( utility.isNode( elm.oMasthead.settings.countryLinkElm ) ) {
				elm.oMasthead.settings.countryLinkUrl = elm.oMasthead.settings.countryLinkElm.getAttribute( 'href' );
				elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--has-country-selector' );

				// Add aria and onclick cunfction
				elm.oMasthead.settings.countryLinkElm.setAttribute( 'role', 'button' );
				elm.oMasthead.settings.countryLinkElm.setAttribute( 'aria-expanded', 'false' );
				elm.oMasthead.settings.countryLinkElm.classList.add( 'js-m-site-country-selection__country' );

				elm.oMasthead.settings.countryLinkElm.addEventListener( 'click', function listener( e ) {
					var contentHref;

					e.preventDefault();

					if ( elm.oMasthead.settings.busy || elm.oMasthead.settings.changeInProgress ) {
						// Do nothing
					} else {
						elm.oMasthead.settings.busy = true;
						elm.oMasthead.settings.changeInProgress = true;
						if ( elm.oMasthead.settings.countryLinkUrl === elm.oMasthead.settings.current ) {
							// Close country selector if currently open
							oMastheadFn.close( elm, true, true );
						} else if ( utility.isNode( elm.oMasthead.settings.countryElm ) ) {
							// If the country options are already on the page, open the country selector
							oMastheadFn.open( elm, elm.oMasthead.settings.countryLinkElm, elm.oMasthead.settings.countryElm );
						} else {
							// If the country options are not on the page load them into the overall navigation area and add appropriate aria
							elm.oMasthead.settings.countryLinkElm.setAttribute( 'aria-controls', 'o-masthead-navigation__country-listing' );
							elm.oMasthead.settings.countryElm = utility.htmlStringToElement( '<div id="o-masthead-navigation__country-listing" ' +
							'class="o-masthead-navigation__country-listing" aria-hidden="true" style="display:none"><div class="a-loading-indicator-container u-align--center">' +
							'<div class="a-loading-indicator" role="alert"><span class="a-loading-indicator__message">' +
							oMastheadFn.settings.loadingText + '</span></div></div></div>' );

							contentHref = elm.oMasthead.settings.countryLinkElm.getAttribute( 'href' ) + ' .m-country-selection';

							utility.requestLoadInto( elm.oMasthead.settings.countryElm, contentHref, function cb( response, status ) {
								if ( status >= 200 && status < 400 ) {
									elm.oMasthead.settings.wholeNavElm.querySelector( '.l-content-container' ).append( elm.oMasthead.settings.countryElm );
									setTimeout( function timeoutFn() {
										elm.oMasthead.settings.pageWrapperElm.style.minHeight = utility.convertToPx( elm.oMasthead.settings.wholeNavElm.offsetHeight );
										// Open the country selector
										oMastheadFn.open( elm, elm.oMasthead.settings.countryLinkElm, elm.oMasthead.settings.countryElm );
									}, FRAMEWORK.timings.current.t500ms );
								} else {
									elm.oMasthead.settings.countryElm = null; // Errored so clear the variable
									oMastheadFn.close( elm, true, true ); // If error then just close the menu
								}
							});
						}
					}
				});
			}
		},

		buildPrimaryNav : function( elm ) {
			var newNavElm = '',
				landingPageLinkTop = !elm.classList.contains( 'o-masthead--landing-page-bottom' );

			oMastheadFn.setupCloseButton( elm );

			if ( elm.oMasthead.settings.navBasicLinks.length > 0 ) {
				// Build basic version of primary nav
				oMastheadFn.buildPrimaryNavBasic( elm );
			} else {
				if ( landingPageLinkTop ) {
					// Do nothing
				} else {
					elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation--landing-page-bottom' );
				}
				/*
				 * Loop through the primary nav section.
				 * Create a unique ID for each main menu item and add it to the menu item
				 * Use the heading text for the menu item for the primary nav tab text and create a primary nav tab link
				 */
				elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation__section' ).forEach( function loop( currentSectionArea ) {
					var sectionId = utility.makeId( 'primary-nav-' ),
						sectionHeadingElm = currentSectionArea.querySelector( '.m-primary-navigation__section-heading' ),
						sectionAllLinkElm = currentSectionArea.querySelector( '.m-primary-navigation-sub-section__link' ),
						sectionTitle = sectionHeadingElm.textContent,
						selectedSectionClass = '';

					oMastheadFn.adjustNavPositions( elm, currentSectionArea );

					if ( sectionHeadingElm.querySelector( 'a' ) === null && utility.isNode( sectionAllLinkElm ) ) {
						utility.wrapInner( sectionHeadingElm, utility.htmlStringToElement( '<a href="' + sectionAllLinkElm.getAttribute( 'href' ) + '"></a>' ) );
					}
					if ( currentSectionArea.classList.contains( 'is-selected' ) ) {
						selectedSectionClass = 'is-selected';
					}

					newNavElm = newNavElm + '<li><a href="#' + sectionId + '" class="o-masthead__primary-nav-link ' + selectedSectionClass +
						'">' + sectionTitle + '</a></li>';

					currentSectionArea.setAttribute( 'id', sectionId );

					// Loop through all sub sections and setup for mobile view show/hide functionality
					currentSectionArea.querySelectorAll( '.m-primary-navigation-sub-section__heading' ).forEach( function innerLoop( currentSubSectionElm ) {
						var subSectionId = utility.makeId( 'primary-nav-sub-' ),
							subSectionLinkElm,
							subSectionContentElm;

						utility.wrapInner( currentSubSectionElm, utility.htmlStringToElement( '<a href="#' + subSectionId +
						'" role="button" aria-controls="' + subSectionId + '" aria-expanded="false"></a>' ) );
						subSectionLinkElm = currentSubSectionElm.querySelector( 'a' );

						subSectionContentElm = currentSubSectionElm.closest( '.m-primary-navigation-sub-section' ).querySelector( '.m-primary-navigation-sub-section__link-list' );
						oMastheadFn.instantHideShow( subSectionContentElm, true, false );

						// Make sure all the links are tertiary links
						subSectionContentElm.querySelectorAll( 'a:not(.a-button)' ).forEach( function innerLoop2( linkElm ) {
							linkElm.classList.add( 'a-button' );
							linkElm.classList.add( 'a-button--tertiary' );
							utility.wrapInner( linkElm, utility.htmlStringToElement( '<span class="a-button__inner"></span>' ) );
						});

						elm.oMasthead.settings.navSubSections.push( [ subSectionLinkElm, subSectionContentElm ] );

						subSectionLinkElm.addEventListener( 'click', function listener( e ) {
							e.preventDefault();
							if ( elm.oMasthead.settings.busy ) {
								// Do nothing
							} else {
								elm.oMasthead.settings.busy = true;
								oMastheadFn.accordionSubSections( elm, subSectionLinkElm, subSectionContentElm, e );
							}
						});
					});

					// If the landing page link exists and should be displayed at the top (default) then move to below the section heading
					if ( landingPageLinkTop && sectionAllLinkElm ) {
						sectionHeadingElm.insertAdjacentElement( 'afterend', sectionAllLinkElm );
						currentSectionArea.classList.add( 'm-primary-navigation__section--landing-page-link' );
					}
				});

				elm.oMasthead.settings.allNavSectionDescriptions = elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation-sub-section__description' );
				elm.oMasthead.settings.navSectionHeadingLinks = elm.oMasthead.settings.wholePageElm.querySelectorAll( '.m-primary-navigation__section-heading a' );

				if ( utility.isNode( elm.oMasthead.settings.navLinkElm ) && newNavElm !== '' ) {
					// Using the built up primary nav links add this to the masthead
					elm.oMasthead.settings.navLinkElm.insertAdjacentElement( 'afterend', utility.htmlStringToElement( '<nav class="o-masthead__primary-nav" aria-label="' +
					FRAMEWORK.locale.settings.oMasthead.primaryNavigationLabel + '">' +
					'<ul class="a-list-plain">' + newNavElm + '</ul></nav>' ) );
				}

				// Loop through all the links in the new primary nav and run link setup on them
				elm.oMasthead.settings.wholePageElm.querySelectorAll( '.o-masthead__primary-nav-link' ).forEach( function loop( thisLinkElm ) {
					oMastheadFn.setupLink( elm, thisLinkElm, document.querySelector( thisLinkElm.getAttribute( 'href' ) ) );
				});
			}
		},

		adjustNavPositions : function( elm, section ) {
			var columnContainer = section.querySelector( '.l-columns' ),
				allColumns = section.querySelectorAll( '.l-columns__column' );
			if ( allColumns.length >= 3 ) {
				// Adjust layout for tablet to avoid the close button
				section.classList.add( 'm-primary-navigation__section--close-adjust-medium' );
			}

			if ( allColumns.length < 4 || ( allColumns.length > 3 && allColumns[ allColumns.length - 1 ].classList.contains( 'm-card' ) ) ) {
				// If less than 4 columns or the last column is a card, do nothing
			} else if ( ( columnContainer.classList.contains( 'l-columns--4-large' ) && allColumns.length === 4 ) ||
				( columnContainer.classList.contains( 'l-columns--5-large' ) && allColumns.length === 5 ) ) {
				// If 4 of 5 columns and last is not a card, adjust the layout at desktop to avoid the close button
				section.classList.add( 'm-primary-navigation__section--close-adjust' );
			} else {
				// Do nothing
			}
		},

		buildPrimaryNavBasic : function( elm ) {
			var newNavElm = '';

			/*
			 * Loop through the primary nav section.
			 * Create a unique ID for each main menu item and add it to the menu item
			 * Use the heading text for the menu item for the primary nav tab text and create a primary nav tab link
			 */
			elm.oMasthead.settings.navBasicLinks.forEach( function loop( basicLink ) {
				var selectedSectionClass = '';

				if ( basicLink.classList.contains( 'is-selected' ) ) {
					selectedSectionClass = 'is-selected';
				}

				newNavElm = newNavElm + '<li><a href="' + basicLink.getAttribute( 'href' ) +
				'" class="o-masthead__primary-nav-link ' + selectedSectionClass + '">' + basicLink.textContent + '</a></li>';
			});

			elm.oMasthead.settings.allNavSectionDescriptions = document.querySelectorAll( '.m-primary-navigation-sub-section__description' );

			// Using the built up primary nav links add this to the masthead
			if ( newNavElm === '' ) {
				// Do nothing
			} else {
				elm.oMasthead.settings.navLinkElm.insertAdjacentHTML( 'afterend', '<nav class="o-masthead__primary-nav o-masthead__primary-nav--basic">' +
			'<ul class="a-list-plain">' + newNavElm + '</ul></nav>' );
			}
		},

		setupCloseButton : function( elm ) {
			// Add close button tc
			var buttonHtml = '<button class="a-button a-button--tertiary a-button--tertiary-shallow a-button--cancel o-masthead-navigation__close" type="button">' +
				'<span class="a-button__inner">' + oMastheadFn.settings.closeMenu + '</span></button>',
				buttonCloseFunc = function( e ) {
					e.preventDefault();
					if ( elm.oMasthead.settings.busy ) {
						// Do nothing
					} else {
						elm.oMasthead.settings.busy = true;
						oMastheadFn.close( elm, true, true );
					}
				};

			// Button for mobile view
			elm.oMasthead.settings.closeButtonTop = utility.htmlStringToElement( buttonHtml );
			elm.oMasthead.settings.wholeNavElm.querySelector( '.l-content-container' ).prepend( elm.oMasthead.settings.closeButtonTop );
			utility.wrap( elm.oMasthead.settings.closeButtonTop, utility.htmlStringToElement( '<div class="o-masthead-navigation__close-wrapper' +
				' o-masthead-navigation__close-wrapper--top"></div>' ) );

			elm.oMasthead.settings.closeButtonTop.addEventListener( 'click', function listener( e ) {
				buttonCloseFunc( e );
			});

			// Button for tablet and desktop view
			elm.oMasthead.settings.closeButtonBottom = utility.htmlStringToElement( buttonHtml );
			elm.oMasthead.settings.wholeNavElm.querySelector( '.l-content-container' ).append( elm.oMasthead.settings.closeButtonBottom );
			utility.wrap( elm.oMasthead.settings.closeButtonBottom, utility.htmlStringToElement( '<div class="o-masthead-navigation__close-wrapper' +
				' o-masthead-navigation__close-wrapper--bottom"></div>' ) );

			elm.oMasthead.settings.closeButtonBottom.addEventListener( 'click', function listener( e ) {
				buttonCloseFunc( e );
			});
		},

		checkSection : function( linkElm, currentSectionUrl, testLinkElm, testLinkUrl ) {
			var sectionOpen = false;
			if ( linkElm === testLinkElm || currentSectionUrl === testLinkUrl ) {
				sectionOpen = true;
			}
			return sectionOpen;
		},

		checkAllLinks : function( elm, linkElm ) {
			var linkOpen = linkElm === elm.oMasthead.settings.navLinkElm || linkElm === elm.oMasthead.settings.searchLinkElm;
			linkOpen = linkOpen || linkElm === elm.oMasthead.settings.loggedInLinkElm;

			return linkOpen;
		},

		open : function( elm, linkElm, areaElm ) {
			var vars = {
					currentSectionUrl : null,
					sameSection : false,
					transitionBetweenMenus : null,
				},
				test1,
				test2;

			oMastheadFn.toggleSiteSwitcher( elm, true ); // Close siteswitcher

			if ( elm.oMasthead.settings.current ) {
				vars.currentSectionUrl = elm.oMasthead.settings.current;
			}
			vars.sameSection = vars.currentSectionUrl === linkElm.getAttribute( 'href' );
			vars.transitionBetweenMenus = !vars.sameSection && vars.currentSectionUrl !== null;
			test1 = oMastheadFn.checkSection( linkElm, vars.currentSectionUrl, elm.oMasthead.settings.loginLinkElm, elm.oMasthead.settings.loginLinkUrl );
			test2 = oMastheadFn.checkSection( linkElm, vars.currentSectionUrl, elm.oMasthead.settings.countryLinkElm, elm.oMasthead.settings.countryLinkUrl );

			if ( test1 || test2 ) {
				vars.transitionBetweenMenus = false;
			} else if ( elm.oMasthead.settings.currentBreakpoint === utility.smallTag ) {
				vars.transitionBetweenMenus = true;
			} else if ( oMastheadFn.checkSection( linkElm, vars.currentSectionUrl, elm.oMasthead.settings.loggedInLinkElm, elm.oMasthead.settings.loggedInLinkUrl ) ) {
				vars.transitionBetweenMenus = false;
			} else if ( vars.transitionBetweenMenus ) {
				elm.oMasthead.settings.wholeNavElm.style.minHeight = utility.convertToPx( elm.oMasthead.settings.wholeNavElm.offsetHeight );
			} else {
				// Do nothing
			}

			oMastheadFn.openPart2( elm, linkElm, areaElm, vars );
		},

		openPart2 : function( elm, linkElm, areaElm, vars ) {
			var test1,
				test2;
			// If the current open link is not the same as the link being opened do the following
			if ( vars.sameSection ) {
				oMastheadFn.close( elm, !vars.transitionBetweenMenus, true );
			} else {
				oMastheadFn.close( elm, !vars.transitionBetweenMenus, false );

				/* eslint-disable-next-line complexity */
				setTimeout( function timeoutFn() {
					if ( !( elm.oMasthead.settings.navElm && elm.oMasthead.settings.navElm.classList.contains( 'm-primary-navigation' ) ) && elm.oMasthead.settings.orphanPrimaryNavElm ) {
						// If the login or country selection link and there is no primary nav make sure any get support links are hidden
						if ( linkElm === elm.oMasthead.settings.loginLinkElm || linkElm === elm.oMasthead.settings.countryLinkElm ) {
							elm.oMasthead.settings.orphanPrimaryNavElm.style.display = 'none';
						} else {
							elm.oMasthead.settings.orphanPrimaryNavElm.style.display = 'block';
						}
					}
					if ( linkElm === elm.oMasthead.settings.loginLinkElm || linkElm === elm.oMasthead.settings.loggedInLinkElm ) {
						elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--narrow-megamenu' );
						elm.oMasthead.settings.narrowMenu = true;
					}

					oMastheadFn.instantHideShow( elm.oMasthead.settings.wholeNavElm, false, false );

					if ( elm.oMasthead.settings.currentBreakpoint === utility.smallTag && oMastheadFn.checkAllLinks( elm, linkElm ) ) {
						/*
						 * If at mobile and the link is either menu or search and the current open link is NOT menu or search then
						 * open the search menu and then open the main menu as well
						 */
						test1 = vars.currentSectionUrl !== elm.oMasthead.settings.navLinkElm && vars.currentSectionUrl !== elm.oMasthead.settings.searchLinkUrl;
						test2 = vars.currentSectionUrl !== elm.oMasthead.settings.loggedInLinkUrl;
						if ( test1 && test2 ) {
							utility.fade( elm.oMasthead.settings.searchElm, oMastheadFn.settings.animationSpeed, { variant : 'in' });
							utility.fade( elm.oMasthead.settings.loggedInElm, oMastheadFn.settings.animationSpeed, { variant : 'in' });

							oMastheadFn.openSection( elm, elm.oMasthead.settings.navLinkElm, elm.oMasthead.settings.navElm, vars.transitionBetweenMenus );
							elm.oMasthead.settings.navLinkElm.focus();
						}
					} else {
						oMastheadFn.openSection( elm, linkElm, areaElm, vars.transitionBetweenMenus );
					}
				}, oMastheadFn.settings.animationSpeed + 100 );
			}
		},

		openSection : function( elm, linkElm, areaElm, transitionSection ) {
			var currentHeight,
				animationDirection;

			// If both the link and area provided can be found on the page do the following
			if ( utility.isNode( linkElm ) && utility.isNode( areaElm ) ) {
				elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--is-open' );
				elm.oMasthead.settings.pageWrapperElm.classList.add( 'is-open' );
				elm.oMasthead.settings.current = linkElm.getAttribute( 'href' );

				if ( elm.oMasthead.settings.searchLinkElm && linkElm === elm.oMasthead.settings.searchLinkElm ) {
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--search-open' );
				}

				if ( !( elm.oMasthead.settings.currentBreakpoint !== utility.smallTag && !elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--wont-fit-extra-content' ) ) ) {
					oMastheadFn.instantHideShow( elm.oMasthead.settings.extraContentAreaElm, true, false );
				}
				oMastheadFn.instantHideShow( elm.oMasthead.settings.wholeNavElm, false, false );
				currentHeight = elm.oMasthead.settings.wholeNavElm.offsetHeight;
				elm.oMasthead.settings.wholeNavElm.style.minHeight = 0;

				// Update the aria attributes
				linkElm.classList.add( 'is-open' );
				linkElm.setAttribute( 'aria-expanded', 'true' );

				if ( linkElm === elm.oMasthead.settings.countryLinkElm ) {
					if ( elm.oMasthead.settings.mastheadNotification ) {
						elm.oMasthead.settings.mastheadNotificationInstance.hide();
					}
					oMastheadFn.instantHideShow( elm.oMasthead.settings.mastheadElm, true, false );
				}

				if ( linkElm.classList.contains( 'o-masthead__primary-nav-link' ) ) {
					// If the link forms part of the primary nav set all the aria attributes for the whole of nav and show
					elm.oMasthead.settings.navLinkElm.setAttribute( 'aria-expanded', 'true' );
					elm.oMasthead.settings.navLinkElm.classList.add( 'is-open' );
					utility.fade( elm.oMasthead.settings.navElm, oMastheadFn.settings.animationSpeed, { variant : 'in' });
				} else {
					// Do nothing
				}

				oMastheadFn.openSectionPart2( elm, {
					areaElm : areaElm,
					transitionSection : transitionSection,
					animationDirection : animationDirection,
					currentHeight : currentHeight,
					linkElm : linkElm,
				});
			} else {
				elm.oMasthead.settings.busy = false;
			}
		},

		openSectionPart2 : function( elm, vars ) {
			var newHeight,
				waitForFade = 0;

			// If the link is the main menu link. Loop through all the primary nav items, setting the aria attributes correctly and fade them all in
			if ( vars.linkElm === elm.oMasthead.settings.navLinkElm ) {
				waitForFade = ( oMastheadFn.settings.animationSpeed / 3 ) + 100;
				if ( elm.oMasthead.settings.navBasicLinks.length === 0 ) {
					document.querySelectorAll( '.o-masthead__primary-nav-link' ).forEach( function loop( thisLinkElm ) {
						var thisAreaElm = document.querySelector( thisLinkElm.getAttribute( 'href' ) );

						thisLinkElm.setAttribute( 'aria-expanded', 'true' );
						utility.fade( thisAreaElm, ( oMastheadFn.settings.animationSpeed / 3 ), { variant : 'in' });
					});
				} else {
					elm.oMasthead.settings.navLinkElm.setAttribute( 'aria-expanded', 'true' );
					elm.oMasthead.settings.navLinkElm.classList.add( 'is-open' );
					utility.fade( elm.oMasthead.settings.navElm, ( oMastheadFn.settings.animationSpeed / 3 ), { variant : 'in' });
				}
			}

			// Show the nav area, get the final height then hide again.
			oMastheadFn.instantHideShow( vars.areaElm, false, false );
			if ( elm.oMasthead.settings.currentBreakpoint !== utility.smallTag && elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--fit-tabs' ) ) {
				oMastheadFn.alignDescriptions( elm, elm.oMasthead.settings.currentBreakpoint );
			}
			newHeight = elm.oMasthead.settings.wholeNavElm.offsetHeight;
			elm.oMasthead.settings.pageWrapperElm.style.minHeight = utility.convertToPx( newHeight );
			oMastheadFn.instantHideShow( vars.areaElm, true, false );

			// Update aria and then slide in the nav area
			setTimeout( function timeoutFn() {
				if ( vars.transitionSection ) {
					oMastheadFn.instantHideShow( elm.oMasthead.settings.wholeNavElm, false, false );
					utility.slideToggle( elm.oMasthead.settings.wholeNavElm, oMastheadFn.settings.animationSpeed, {
						variant : 'down',
						customStartHeight : vars.currentHeight,
						customEndHeight : newHeight,
					});
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--show-close' );
					utility.fade( vars.areaElm, oMastheadFn.settings.animationSpeed, {
						variant : 'in',
						callback : function() {
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'height' );
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'max-height' );
							elm.oMasthead.settings.changeInProgress = false;
							elm.oMasthead.settings.busy = false;
						},
					});
				} else if ( elm.oMasthead.settings.narrowMenu ) {
					utility.slideToggle( vars.areaElm, oMastheadFn.settings.animationSpeed, {
						variant : 'down',
						callback : function() {
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'height' );
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'max-height' );
							elm.oMasthead.settings.changeInProgress = false;
							elm.oMasthead.settings.busy = false;
						},
					});
				} else {
					vars.areaElm.style.opacity = 0;
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--show-close' );
					utility.slideToggle( vars.areaElm, oMastheadFn.settings.animationSpeed, {
						variant : 'down',
						fade : true,
						callback : function() {
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'height' );
							elm.oMasthead.settings.wholeNavElm.style.removeProperty( 'max-height' );
							elm.oMasthead.settings.changeInProgress = false;
							elm.oMasthead.settings.busy = false;
						},
					});
				}
			}, waitForFade );

			// If the section being opened is search transfer the focus straight to the search input/
			if ( vars.linkElm === elm.oMasthead.settings.searchLinkElm && elm.oMasthead.settings.searchInputElm !== null ) {
				elm.oMasthead.settings.searchInputElm.focus();
			}
		},

		close : function( elm, closeAll, closeOverlay ) {
			var navigationInteval;

			elm.oMasthead.settings.current = null;

			oMastheadFn.closeSections( elm, oMastheadFn.settings.animationSpeed );
			oMastheadFn.closeSearchLoginLoggedIn( elm.oMasthead.settings.searchElm, true );
			oMastheadFn.closeSearchLoginLoggedIn( elm.oMasthead.settings.loginElm, true );
			oMastheadFn.closeSearchLoginLoggedIn( elm.oMasthead.settings.loggedInElm, true );

			if ( closeAll ) {
				setTimeout( function timeoutFn() {
					if ( closeOverlay ) {
						if ( elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) ) {
							if ( elm.oMasthead.settings.wholeNavElm.classList.contains( 'is-animating' ) ) {
								navigationInteval = setInterval( function intervalFn() {
									if ( elm.oMasthead.settings.wholeNavElm.classList.contains( 'is-animating' ) ) {
										// Do nothing still animating
									} else {
										clearInterval( navigationInteval );
										elm.oMasthead.settings.pageWrapperElm.classList.remove( 'is-open' );
										elm.oMasthead.settings.wholePageElm.classList.remove( 'js-o-masthead--is-open' );
										utility.slideToggle( elm.oMasthead.settings.extraContentAreaElm, oMastheadFn.settings.animationSpeed, {
											variant : 'down',
											overlapMargin : true,
										});
										elm.oMasthead.settings.changeInProgress = false;
										elm.oMasthead.settings.busy = false;
									}
								}, 10 );
							} else {
								utility.slideToggle( elm.oMasthead.settings.wholeNavElm, oMastheadFn.settings.animationSpeed, {
									variant : 'up',
									callback : function() {
										elm.oMasthead.settings.pageWrapperElm.classList.remove( 'is-open' );
										elm.oMasthead.settings.wholePageElm.classList.remove( 'js-o-masthead--is-open' );
										utility.slideToggle( elm.oMasthead.settings.extraContentAreaElm, oMastheadFn.settings.animationSpeed, {
											variant : 'down',
											overlapMargin : true,
										});
										elm.oMasthead.settings.changeInProgress = false;
										elm.oMasthead.settings.busy = false;
									},
								});
							}
						} else {
							// Do nothing - close being forced by third parameter, but not needed since wholeNavElm is already closed!
							elm.oMasthead.settings.busy = false;
						}
					} else {
						utility.slideToggle( elm.oMasthead.settings.wholeNavElm, oMastheadFn.settings.animationSpeed, { variant : 'up' });
					}
				}, 20 );
			}

			oMastheadFn.instantHideShow( elm.oMasthead.settings.mastheadElm, false, false );

			elm.oMasthead.settings.pageWrapperElm.style.minHeight = 'auto';
			elm.oMasthead.settings.wholePageElm.classList.remove( 'js-o-masthead--show-close' );
			elm.oMasthead.settings.wholePageElm.classList.remove( 'js-o-masthead--search-open' );
			elm.oMasthead.settings.wholePageElm.classList.remove( 'js-o-masthead--narrow-megamenu' );
			elm.oMasthead.settings.narrowMenu = false;
		},

		closeSearchLoginLoggedIn : function( sectionElm, fade ) {
			if ( utility.isNode( sectionElm ) ) {
				if ( fade ) {
					utility.fade( sectionElm, oMastheadFn.settings.animationSpeed, { variant : 'out' });
				} else {
					utility.slideToggle( sectionElm, oMastheadFn.settings.animationSpeed, { variant : 'up' });
				}
			}
		},

		closeSections : function( elm, speed ) {
			var linkSelector = '.o-masthead__skip-links a.is-open, .o-masthead__primary-nav:not(.o-masthead__primary-nav--basic) a, .js-m-site-country-selection__country.is-open';
			// Loop through all open sections a reset the aria attributes and text, then hide the area associated to them.
			document.querySelectorAll( linkSelector ).forEach( function loop( openLinkElm ) {
				var openAreaElm;

				openLinkElm.classList.remove( 'is-open' );
				openLinkElm.setAttribute( 'aria-expanded', 'false' );

				if ( elm.oMasthead.settings.mastheadNotification ) {
					elm.oMasthead.settings.mastheadNotificationInstance.show();
				}

				if ( openLinkElm.classList.contains( 'js-m-site-country-selection__country' ) ) {
					openAreaElm = elm.oMasthead.settings.countryElm;
				} else {
					openAreaElm = document.querySelector( openLinkElm.getAttribute( 'href' ) );
				}

				if ( elm.oMasthead.settings.narrowMenu ) {
					utility.slideToggle( openAreaElm, speed, { variant : 'up' });
				} else {
					utility.fade( openAreaElm, speed, { variant : 'out' });
				}
			});
		},

		accordionSubSections : function( elm, sectionLinkElm, sectionContentElm ) {
			// If on small screen or tabs not fitting allow accordion of sub sections
			if ( elm.oMasthead.settings.currentBreakpoint === utility.smallTag || !elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--fit-tabs' ) ) {
				if ( sectionLinkElm.classList.contains( 'is-open' ) ) {
					sectionLinkElm.classList.remove( 'is-open' );
					sectionLinkElm.setAttribute( 'aria-expanded', 'false' );
					utility.slideToggle( sectionContentElm, oMastheadFn.settings.animationSpeed, {
						variant : 'up',
						callback : function() {
							elm.oMasthead.settings.busy = false;
						},
					});
				} else {
					// Hide all open sections
					elm.oMasthead.settings.navSubSections.forEach( function loop( item ) {
						if ( item[ 0 ].classList.contains( 'is-open' ) ) {
							item[ 0 ].classList.remove( 'is-open' );
							item[ 0 ].setAttribute( 'aria-expanded', 'false' );
							utility.slideToggle( item[ 1 ], oMastheadFn.settings.animationSpeed, { variant : 'up' });
						}
					});

					sectionLinkElm.classList.add( 'is-open' );
					sectionLinkElm.setAttribute( 'aria-expanded', 'true' );
					utility.slideToggle( sectionContentElm, oMastheadFn.settings.animationSpeed, {
						variant : 'down',
						callback : function() {
							var sectionOffset = utility.offset( sectionLinkElm ).top,
								windowOffset = window.pageYOffset,
								animationLoops;

							if ( sectionOffset < windowOffset ) {
								animationLoops = oMastheadFn.settings.animationSpeed / 20;
								animationLoops = Number.parseInt( animationLoops, 10 );

								oMastheadFn.repositionNavigation( sectionLinkElm, animationLoops, windowOffset );
							}
							elm.oMasthead.settings.busy = false;
						},
					});
				}
				elm.oMasthead.settings.navSectionHeadingLinks.forEach( function loop( linkElm ) {
					linkElm.removeAttribute( 'tabindex' );
				});
				setTimeout( function timeoutFn() {
					elm.oMasthead.settings.pageWrapperElm.style.minHeight = utility.convertToPx( elm.oMasthead.settings.wholeNavElm.offsetHeight );
				}, oMastheadFn.settings.animationSpeed + 20 );
			} else {
				elm.oMasthead.settings.navSectionHeadingLinks.forEach( function loop( linkElm ) {
					linkElm.setAttribute( 'tabindex', '-1' );
					linkElm.setAttribute( 'aria-expanded', 'true' );
				});
				oMastheadFn.instantHideShow( sectionContentElm, false, false );
				elm.oMasthead.settings.busy = false;
			}
		},

		repositionNavigation : function( sectionLinkElm, animationLoops, windowOffset ) {
			var newWindowOffset = windowOffset,
				newAnimationLoops = animationLoops;

			if ( newAnimationLoops > 0 ) {
				setTimeout( function timeoutFn() {
					var sectionOffset = utility.offset( sectionLinkElm ).top;

					if ( newAnimationLoops === 1 ) {
						newWindowOffset = sectionOffset;
					} else {
						newWindowOffset -= ( ( newWindowOffset - sectionOffset ) / newAnimationLoops );
					}
					window.scrollTo( 0, newWindowOffset );
					newAnimationLoops -= 1;
					oMastheadFn.repositionNavigation( sectionLinkElm, newAnimationLoops, newWindowOffset );
				}, 10 );
			}
		},

		onKeydown : function( e, linkElm, elm ) {
			var hasHeaderLink,
				allHeaderLinks,
				visibleNavLinks,
				visibleMenuLinks,
				currentLinkElm,
				bodyLinkElm,
				currentIndex,
				prevLinkElm,
				lastHeaderLinkElm;

			// When tab has been pressed and a nav item is open do the following
			if ( e.key === 'Tab' && elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) ) {
				hasHeaderLink = linkElm.closest( 'header' ) !== null;
				allHeaderLinks = [].slice.call( elm.oMasthead.settings.wholePageElm.querySelectorAll( '.o-masthead a, .m-site-country-selection a' ) ).filter( function filterFn( el ) {
					var isVisible = false;
					if ( utility.isVisible( el ) && el.getAttribute( 'tabindex' ) !== '-1' ) {
						isVisible = true;
					}
					return isVisible;
				});
				visibleNavLinks = [].slice.call( elm.oMasthead.settings.wholeNavElm.querySelectorAll( 'a, input, button' ) ).filter( function filterFn( el ) {
					var isVisible = false;
					if ( utility.isVisible( el ) && el.getAttribute( 'tabindex' ) !== '-1' ) {
						isVisible = true;
					}
					return isVisible;
				});

				if ( hasHeaderLink ) {
					// If the link is part of the header area...
					oMastheadFn.keydownHeaderLink({
						event : e,
						currentIndex : currentIndex,
						allHeaderLinks : allHeaderLinks,
						linkElm : linkElm,
						prevLinkElm : prevLinkElm,
						visibleNavLinks : visibleNavLinks,
					});
				} else {
					// If the link is not part of the header area...
					bodyLinkElm = linkElm.closest( '.o-masthead-navigation' ).length === 0;
					visibleMenuLinks = [].slice.call( elm.oMasthead.settings.wholePageElm.querySelectorAll( '.o-masthead__skip-links li' ) ).filter( function filterFn( el ) {
						var isVisible = false;
						if ( utility.isVisible( el ) && el.getAttribute( 'tabindex' ) !== '-1' ) {
							isVisible = true;
						}
						return isVisible;
					});
					visibleMenuLinks.forEach( function loop( listItemElm ) {
						visibleMenuLinks.concat( [].slice.call( listItemElm.querySelectorAll( 'a' ) ) );
					});

					if ( bodyLinkElm ) {
						// If the link is not part of the header or navigation areas move the user back into the header system.
						e.preventDefault();

						lastHeaderLinkElm = allHeaderLinks[ allHeaderLinks.length - 1 ];
						if ( lastHeaderLinkElm.classList.add( 'is-open' ) ) {
							visibleMenuLinks[ visibleMenuLinks.length - 1 ].focus();
						} else {
							lastHeaderLinkElm.focus();
						}
					} else {
						oMastheadFn.keydownNotBodyLink( elm, {
							currentLinkElm : currentLinkElm,
							allHeaderLinks : allHeaderLinks,
							event : e,
							visibleNavLinks : visibleNavLinks,
							linkElm : linkElm,
							currentIndex : currentIndex,
						});
					}
				}
			}
		},

		keydownHeaderLink : function( vars ) {
			if ( vars.event.shiftKey ) {
				/*
				 * If the shift key has also been pressed
				 * Get the index of the link in comparison to other links within the header
				 */
				vars.currentIndex = vars.allHeaderLinks.indexOf( vars.linkElm );
				/*
				 * If the link is not the first link in the header check if the previous link is open.
				 * If is open then move to the last link within the open navigation. Otherwise just move to the previous link.
				 */
				if ( vars.currentIndex > 0 ) {
					vars.prevLinkElm = vars.allHeaderLinks[ vars.currentIndex - 1 ];
					if ( vars.prevLinkElm.classList.contains( 'is-open' ) ) {
						vars.event.preventDefault();
						vars.visibleNavLinks[ vars.visibleNavLinks.length - 1 ].focus();
					}
				}
			} else if ( vars.linkElm.classList.contains( 'is-open' ) && vars.visibleNavLinks.length > 0 ) {
			/*
			 * If the current link is set to open and the contents of the open area has links within it.
			 * Move the user into the open navigation.
			 * If the current link is not set to open and the last link in the header move the user back to the first link in the header.
			 */
				vars.event.preventDefault();
				vars.visibleNavLinks[ 0 ].focus();
			} else if ( vars.allHeaderLinks.indexOf( vars.linkElm ) >= vars.allHeaderLinks.length - 1 ) {
				vars.event.preventDefault();
				vars.allHeaderLinks[ 0 ].focus();
			} else {
				// Do nothing
			}
		},

		keydownNotBodyLink : function( elm, vars ) {
			vars.currentLinkElm = vars.allHeaderLinks.filter( function filterFn( el ) {
				return el.getAttribute( 'href' ) === elm.oMasthead.settings.current;
			})[ 0 ];
			if ( vars.event.shiftKey && vars.visibleNavLinks.indexOf( vars.linkElm ) === 0 ) {
				/*
				 * If the shift key has also been pressed and the link is the first one in the visible navigation move
				 * the user back onto the link that opened the navigation.
				 */
				vars.event.preventDefault();
				vars.currentLinkElm.focus();
			} else if ( vars.event.shiftKey && vars.visibleNavLinks.indexOf( vars.linkElm ) === vars.visibleNavLinks.length - 1 ) {
				// Do nothing
			} else if ( vars.visibleNavLinks.indexOf( vars.linkElm ) === vars.visibleNavLinks.length - 1 ) {
				/*
				 * If the link is the last link in the visible navigation move the user to the last link in the header unless the
				 * user opened the navigation from the last link, then move the user to the first link in the header
				 */
				vars.event.preventDefault();

				vars.currentIndex = vars.allHeaderLinks.indexOf( vars.currentLinkElm );
				if ( vars.currentIndex >= vars.allHeaderLinks.length - 1 ) {
					vars.allHeaderLinks[ 0 ].focus();
				} else {
					vars.allHeaderLinks[ vars.currentIndex + 1 ].focus();
				}
			} else {
				// Do nothing
			}
		},

		sizeNavElements : function( elm, breakpoint ) {
			// If mobile then make link not tabbable
			oMastheadFn.tabbableLink( elm.oMasthead.settings.searchLinkElm, breakpoint );
			oMastheadFn.tabbableLink( elm.oMasthead.settings.loggedInLinkElm, breakpoint );
		},

		tabbableLink : function( linkElm, breakpoint ) {
			// If mobile then make link not tabbable
			if ( utility.isNode( linkElm ) ) {
				if ( breakpoint === utility.smallTag && !linkElm.classList.contains( 'js-tabbable' ) ) {
					linkElm.setAttribute( 'tabindex', '-1' );
				} else {
					linkElm.removeAttribute( 'tabindex' );
				}
			}
		},

		positionNav : function( elm, breakpoint ) {
			var menuOpen = false,
				loginOpen = false,
				tabsShowing,
				tabNowShowing;

			// If the menu is open then make sure the page is tall enough to contain the open menu
			if ( elm.oMasthead.settings.pageWrapperElm.classList.contains( 'is-open' ) ) {
				menuOpen = true;
				elm.oMasthead.settings.pageWrapperElm.classList.remove( 'is-open' );
				oMastheadFn.instantHideShow( elm.oMasthead.settings.extraContentAreaElm, false, false );
			}
			// If the login menu is open
			if ( menuOpen && elm.oMasthead.settings.loginLinkUrl === elm.oMasthead.settings.current ) {
				loginOpen = true;
			}

			// Store if tabs are currently being shown and then reset the masthead back to basics
			tabsShowing = elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--fit-tabs' );

			oMastheadFn.fitNavigation( elm, breakpoint );

			tabNowShowing = elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--fit-tabs' );

			// If the menu is open then make sure the page is tall enough to contain the open menu
			if ( menuOpen ) {
				elm.oMasthead.settings.pageWrapperElm.classList.add( 'is-open' );

				if ( elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--wont-fit-extra-content' ) ) {
					oMastheadFn.instantHideShow( elm.oMasthead.settings.extraContentAreaElm, true, false );
				}

				elm.oMasthead.settings.pageWrapperElm.style.minHeight = utility.convertToPx( elm.oMasthead.settings.wholeNavElm );
			}

			oMastheadFn.positionNavPart2( elm, breakpoint, tabsShowing, tabNowShowing );

			// Reset heights on the section descriptions
			elm.oMasthead.settings.allNavSectionDescriptions.forEach( function loop( itemElm ) {
				itemElm.style.minHeight = 0;
			});

			oMastheadFn.positionNavPart3( elm, breakpoint, tabsShowing, tabNowShowing, loginOpen );
		},

		positionNavPart2 : function( elm, breakpoint, tabsShowing, tabNowShowing ) {
			// If on mobile or tabs are not showing allow heading to be clickable
			if ( breakpoint === utility.smallTag || tabsShowing !== tabNowShowing ) {
				if ( breakpoint !== utility.smallTag && tabNowShowing ) {
					elm.oMasthead.settings.navSectionHeadingLinks.forEach( function loop( linkElm ) {
						linkElm.setAttribute( 'tabindex', '-1' );
					});
					elm.oMasthead.settings.navSubSections.forEach( function loop( item ) {
						item[ 0 ].setAttribute( 'tabindex', '-1' );
						item[ 0 ].setAttribute( 'aria-expanded', 'true' );
						oMastheadFn.instantHideShow( item[ 1 ], false, false );
					});
				} else {
					elm.oMasthead.settings.navSectionHeadingLinks.forEach( function loop( item ) {
						item.removeAttribute( 'tabindex' );
					});
					elm.oMasthead.settings.navSubSections.forEach( function loop( item ) {
						item[ 0 ].classList.remove( 'is-open' );
						item[ 0 ].removeAttribute( 'tabindex' );
						item[ 0 ].setAttribute( 'aria-expanded', 'false' );
						oMastheadFn.instantHideShow( item[ 1 ], true, false );
					});
				}
			}
		},

		positionNavPart3 : function( elm, breakpoint, tabsShowing, tabNowShowing, loginOpen ) {
			// If at desktop and the display of primary tabs has changed then close any menu currently open
			if ( ( breakpoint !== utility.smallTag && tabsShowing !== tabNowShowing ) || ( loginOpen && elm.oMasthead.settings.wholePageElm.classList.contains( 'js-o-masthead--wont-fit-login' ) ) ) {
				oMastheadFn.close( elm, true, true );
			} else {
				if ( breakpoint !== utility.smallTag && tabNowShowing ) {
					// If not on small screen or tabs fit match the height of the descriptions across a row
					oMastheadFn.alignDescriptions( elm, breakpoint );
				} else {
					// Do nothing
				}
				elm.oMasthead.settings.pageWrapperElm.style.minHeight = utility.convertToPx( elm.oMasthead.settings.wholeNavElm.offsetHeight );
			}
		},

		alignDescriptions : function( elm, breakpoint ) {
			var visibleDescriptions = [].slice.call( elm.oMasthead.settings.allNavSectionDescriptions ).filter( function filterFn( el ) {
					return utility.isVisible( el );
				}),
				descriptionsInRow,
				start,
				end,
				rows = 1,
				i,
				minHeight,
				rowLoop = function( descriptionElm ) {
					descriptionElm.style.minHeight = utility.convertToPx( minHeight ); // Set the min height on all items within the row
				};

			if ( visibleDescriptions.length > 0 ) {
				if ( breakpoint === utility.mediumTag ) {
					// Calculate the number of rows there are to align
					rows = Math.ceil( visibleDescriptions.length / 3 );
				}
				for ( i = 0; i < rows; i++ ) {
					descriptionsInRow = visibleDescriptions.slice( 0 );

					if ( breakpoint === utility.mediumTag ) {
						start = i * 3; // Start of slice
						end = start + 3; // End of slice
						if ( end > visibleDescriptions.length ) {
							end = visibleDescriptions.length;
						}
						descriptionsInRow = visibleDescriptions.slice( start, end );
					}
					if ( descriptionsInRow.length > 0 ) {
						minHeight = oMastheadFn.findTallestDescription( descriptionsInRow );
						descriptionsInRow.forEach( rowLoop );
					}
				}
			}
		},

		findTallestDescription : function( rowElm ) {
			var minHeight = 0;
			rowElm.forEach( function loop( thisRowElm ) {
				var newHeight = thisRowElm.offsetHeight;
				if ( newHeight > minHeight ) {
					minHeight = newHeight; // If the description is the tallest in this set so far store the min height
				}
			});
			return minHeight;
		},

		fitNavigation : function( elm, breakpoint ) {
			var allClasses = 'js-o-masthead--wont-fit-extra-content js-o-masthead--wont-fit-search js-o-masthead--wont-fit-login js-o-masthead--fit-tabs',
				maxMenuHeight;

			// Reset all classes controlling the layout
			utility.removeClass( elm.oMasthead.settings.wholePageElm, allClasses );

			// If at desktop check for if the tabs and the extra content can fit and add styles appropriately
			if ( breakpoint !== utility.smallTag ) {
				// Get the base height of the masthead
				maxMenuHeight = elm.oMasthead.settings.logoElm.offsetHeight + 2; // Add two pixel to allow for rounding errors when using browser zoom

				// Show the primary nav tabs
				elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--fit-tabs' );

				// Test if the primary nav tabs fit by checking if they have wrapped
				if ( elm.oMasthead.settings.mastheadElm.offsetHeight > maxMenuHeight ) {
					// If the tabs don't fit move the extra content below
					elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-extra-content' );
					// Test if the primary nav tabs fit by checking if they have wrapped and if they still won't fit reduce the search button size
					if ( elm.oMasthead.settings.navContainerElm.offsetHeight > maxMenuHeight ) {
						elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-search' );
						// Test if the primary nav tabs fit by checking if they have wrapped and if they still won't fit reduce the login register area size
						if ( elm.oMasthead.settings.navContainerElm.offsetHeight > maxMenuHeight ) {
							elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-login' );
							// Test if the primary nav tabs fit by checking if they have wrapped and if they still won't fit set to use menu button
							if ( elm.oMasthead.settings.navContainerElm.offsetHeight > maxMenuHeight ) {
								utility.removeClass( elm.oMasthead.settings.wholePageElm, allClasses );
							}
						}
					}

					// Test if the extra content still does not fit and push below
					if ( elm.oMasthead.settings.mastheadElm.offsetHeight > maxMenuHeight ) {
						elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-extra-content' );
						// Test if the search still does not fit and reduce size
						if ( elm.oMasthead.settings.navContainerElm.offsetHeight > maxMenuHeight ) {
							elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-search' );
							// Test if the login register still does not fit and reduce in size
							if ( elm.oMasthead.settings.navContainerElm.offsetHeight > maxMenuHeight ) {
								elm.oMasthead.settings.wholePageElm.classList.add( 'js-o-masthead--wont-fit-login' );
							}
						}
					}
				}
			}
		},
	};

	return {
		initInstance : function( elm ) {
			oMastheadFn.init( elm );
		},
	};
});
